











































import { Component, Vue, Watch } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import Swal from 'sweetalert2';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCloudDownloadAlt, faHistory, faSpinner, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faCloudDownloadAlt);
library.add(faHistory);
library.add(faSpinner);
library.add(faTimes);

@Component({
  components: {
    FontAwesomeIcon,
  },
})
export default class LabelHistory extends Vue {
  private loading = false;
  private labelHistories = [] as any;

  private created() {
    this.loading = true;
    this.$http.get(`/api/address?timestamp=${Date.now()}`).then(
      (response: any) => {
        this.getLabelHistories();
      },
      (err: any) => {
        if (err.status === 404) {
          this.$router.push({ path: 'sender' });
        }
      },
    );
  }

  private getLabelHistories() {
    this.$http.get(`/api/label-history`).then(
      (response: any) => {
        this.labelHistories = response.data;
        this.loading = false;
      },
      (err: any) => {
        this.loading = false;
      },
    );
  }

  private downloadPdf(link) {
    window.open(`${link}?openExternalBrowser=1`);
  }

  private getDateTime(date) {
    const time = new Date(date);
    const formattedDate =
      String(time.getDate()).padStart(2, '0') +
      '-' +
      String(time.getMonth() + 1).padStart(2, '0') +
      '-' +
      time.getFullYear() +
      ' ' +
      String(time.getHours()).padStart(2, '0') +
      ':' +
      String(time.getMinutes()).padStart(2, '0');
    return formattedDate;
  }

  private filteredList() {
    return this.labelHistories.filter((c: any) => {
      const data = JSON.parse(c.data);
      c.data = data;
      return c;
    });
  }
}
